var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.507 5.5053c2.5558 0 4.6538 1.9557 4.8814 4.4522 1.7021 0.60588 2.9211 2.2306 2.9211 4.1415-1.84e-4 2.427-1.9677 4.3946-4.3947 4.3947h-10.572c-2.0179 0-3.6538-1.6359-3.6539-3.6538 0-1.398 0.78569-2.6094 1.9369-3.2238 0.13267-1.7797 1.6174-3.1824 3.4312-3.1824 0.31474 0 0.61975 0.042592 0.90965 0.12212 0.73074-1.7892 2.4874-3.0503 4.5401-3.0504z",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1.3793
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.fd6c41b13ecd3cb9458dbef1d12e9d07.svg";
export { ForwardRef as ReactComponent };